import { put, takeEvery } from 'redux-saga/effects';
import { TRIGGER_SEND_MONEY_BANK_LIST_API } from 'redux/actionTypes';
import { apiCall } from 'services';
import { triggerFetchSendMoneyBankListApiCallSuccess, triggerValidateMobileApiCallSuccess } from 'redux/actions';
import API_CONSTANT from 'constants/apiConstant';
import { ChangeHistory, history, nativeHandler } from 'utils';

function* triggerFetchSendMoneyBankListApiCall(actions) {
	const { data, callback, stopLoader } = actions;
	const TXN_ID = data?.['txnId'];
	const BANK_CODE = data?.['bankCode'];
	let url = API_CONSTANT.URL.SEND_MONEY_BANK_LIST;
	url =
		TXN_ID && BANK_CODE
			? url +
			API_CONSTANT.QUERY_PARAMS.CAMEL_CASE_BANK_CODE +
			BANK_CODE +
			API_CONSTANT.QUERY_PARAMS.SECONDARY_TXN_ID +
			TXN_ID
			: url;
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.CONSUMER,
		url,
		data,
		method: 'GET',
		options: {
			defaultLoader: !stopLoader,
			restrictToast: true,
			dontRemoveLoader: true,
		},
	});
	if (api && api.data) {
		const apiData = api.data.data;
		callback && callback(api.data);
		if (apiData) {
			yield put(triggerFetchSendMoneyBankListApiCallSuccess(apiData));
		}
	} else {
		nativeHandler.removeLoader();
	}
}

export default function* triggerFetchSendMoneyBankListApiCallSaga() {
	yield takeEvery(TRIGGER_SEND_MONEY_BANK_LIST_API, triggerFetchSendMoneyBankListApiCall);
}
